import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import '../../../scss/pages/supplier-inclusion/main.scss';

onDomContentLoaded(() => {});
